<pds-modal #modal [title]="title" [width]="640" (dismiss)="onDismiss()">
  <main class="region-modal">
    <form [formGroup]="form" class="region-modal__form">
      <pds-form-row grid="1-1-1">
        <pds-form-field label="Descrição">
          <input type="text" formControlName="description" [readonly]="mode === 'details'" />
          <small class="region-modal__error" *ngIf="showFieldError('description')">Campo obrigatório</small>
        </pds-form-field>

        <pds-form-field label="CEP origem">
          <input type="text" formControlName="originZipCode" pdsMask="99999-999" [readonly]="mode === 'details'" />
          <small class="region-modal__error" *ngIf="showFieldError('originZipCode')">Campo obrigatório</small>
        </pds-form-field>

        <pds-form-field label="CEP destino">
          <input type="text" formControlName="destinationZipCode" pdsMask="99999-999" [readonly]="mode === 'details'" />
          <small class="region-modal__error" *ngIf="showFieldError('destinationZipCode')">Campo obrigatório</small>
        </pds-form-field>
      </pds-form-row>
    </form>

    <div class="region-modal__audit" *ngIf="mode === 'details' && audit">
      <p><strong>Criado por:</strong> {{ audit.createdBy || '-' }}</p>
      <p><strong>Criado em:</strong> {{ audit.createdAt | date : 'dd/MM/yyyy HH:mm' }}</p>
    </div>

    <pds-form-actions class="region-modal__actions">
      <button pdsButton="terciary" type="button" (click)="close()">Fechar</button>
      <button pdsButton type="button" *ngIf="mode === 'create'" [disabled]="form.invalid || loading" (click)="onClickSave()">Salvar</button>
    </pds-form-actions>
  </main>
</pds-modal>
